import * as React from "react"

const BagIcon = (props) => (
  (
    // ga tracking added for the bag icon click
    <svg xmlns="http://www.w3.org/2000/svg" className={`${props.classProp} ga-bag-icon-click`} width={22} height={19} {...props} >
      <title>{"Atoms/UI/Icons/Bag-item"}</title>
      <g fillRule="evenodd">
        <path
          fill={props.fill_bottom}
          stroke={props.stroke}
          d="M3.905 4.927h14.19a2 2 0 0 1 1.975 1.684l1.56 9.746a2 2 0 0 1-1.976 2.316H2.346A2 2 0 0 1 .37 16.357L1.93 6.61a2 2 0 0 1 1.974-1.684Z"
        />
        <path
          fill={props.fill_top}
          stroke={props.stroke}
          d="M7.012 5.91c0-2.931 1.529-4.91 3.99-4.91 2.462 0 4.01 1.979 4.01 4.91"
        />
      </g>
    </svg>
  )

)

export default BagIcon
